import type { StopsFilters } from '@models/stop'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const stopsKeys = {
  root: () => ['stops'] as const,
  stops: (filters?: StopsFilters) =>
    [
      ...stopsKeys.root(),
      omit(filters, ['take', 'skip']),
      { take: filters?.take, skip: filters?.skip },
    ] as const,
  stopOrders: (stopId: number) =>
    [...stopsKeys.stops(), stopId, 'orders'] as const,
  stopsCount: (filters?: StopsFilters) =>
    ['stopsCount', omit(filters, ['skip'])] as const,
  stop: (id: number) => [...stopsKeys.root(), id] as const,
}

export const stopsUrls = {
  root: keyToUrl(stopsKeys.root()),
  stops: (filters?: StopsFilters) => keyToUrl(stopsKeys.stops(filters)),
  stopOrders: (stopId: number) => keyToUrl(stopsKeys.stopOrders(stopId)),
  stopsCount: (filters?: StopsFilters) =>
    keyToUrl(stopsKeys.stopsCount(filters)),
  stop: (id: number) => keyToUrl(stopsKeys.stop(id)),
}
